// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import hola_2023_theme from '../css/core/hola_2023_theme.module.less';
import {Modal} from '../lib/modal';
// @ts-ignore
import {set, get} from '/util/storage.js';
import {img_url} from './img_url';
import styles from './old_design_popup.module.less';
import {Button} from '../lib/button';
import {use_qs} from '../lib/use_qs';
import {perr} from 'hola_pub_util';
import {useLocation} from 'react-router-dom';

export const Old_design_popup = ()=>{
    const {theme_name} = useContext(Settings_context);
    const [show, set_show] = useState(false);
    const {pathname} = useLocation();
    const qs = use_qs();
    useEffect(()=>{
        const knows = get('hola2023popup');
        // XXX dmitriiz: ignore test page /assign?ex=..ex_v=..next
        if (qs.ex && qs.ex_v && qs.next)
            return;
        // XXX dmitriiz: ignore signin pages
        if (pathname.indexOf('/pro')==0 || pathname == '/signin'
          || pathname == '/signup' || pathname == '/bext_login'
          || pathname.indexOf('/vpn_config')>-1
          || pathname.indexOf('/products')>-1)
        {
            return;
        }
        if (qs.old_design_popup_debug || theme_name!='hola2023' && !knows &&
            get('rebranded_visited'))
        {
            perr({id: 'www_old_design_popup_show'});
            set_show(true);
            set('hola2023popup', 1);
        }
    }, [theme_name]);
    return <div className={hola_2023_theme.root}>
      <Modal width={468} is_open={show} on_close={()=>{
        set_show(false);
      }}>
        <div className={styles.root_cnt}>
          <img src={img_url('hola2023/more_img.svg')} width={200}
            height={128} alt="more_img" className="lazyload"/>
          <p className={hola_2023_theme.p2}><b>Well hello there!</b></p>
          <p className={hola_2023_theme.p2}>We're in the process of giving
            our website a<br/>new look, call it a makeover if you prefer :)</p>
          <p className={hola_2023_theme.p2}>Rest assured, this will be
            updated soon too,<br/>we're on it.</p>
          <Button size='md'
            caption={'Got it'}
            on_click={()=>set_show(false)}
            no_jump
            color='black2023'/>
        </div>
      </Modal>
    </div>;
};
